import React from "react";
import styled from "styled-components";
import {
  useAppDispatch,
  useAppSelector
} from "../../../../../hooks/redux-hooks";
import {
  InputLabel,
  OutlinedInput,
  InputAdornment,
  FormControl,
  IconButton
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { IUserPolicyInfoDto } from "../../../../../types/DTO/IUsersInfoDto";
import { addPolicyComment } from "../../../slice/thunks";
import { updatePolicyCommentText } from "../../../slice";
import { selectPolicyCommentText } from "../../../slice/selectors";

const AddCommentContainer = styled(FormControl)`
  &.add-comment {
    width: 100%;
    max-width: 1200px;
    background-color: #ffffff;
    position: fixed;
    bottom: 0;
    margin: auto;
    padding: 0 0 30px 0;
    z-index: 1;
    border-radius: 20px;

    & > .add-comment-input {
      border-radius: 42px;
    }
  }
`;

interface AddCommentProps {
  selectedCustomer: IUserPolicyInfoDto;
}

export const AddComment: React.FC<AddCommentProps> = ({ selectedCustomer }) => {
  const dispatch = useAppDispatch();
  const customerCommentText = useAppSelector(selectPolicyCommentText);

  return (
    <AddCommentContainer variant="outlined" className="add-comment">
      <InputLabel>Comment...</InputLabel>
      <OutlinedInput
        multiline
        type="text"
        className="add-comment-input"
        value={customerCommentText}
        onChange={(e) => dispatch(updatePolicyCommentText(e.target.value))}
        label="Comment..."
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              onClick={(e) => {
                dispatch(
                  addPolicyComment({
                    userId: selectedCustomer.userId,
                    created: new Date().toString(),
                    note: customerCommentText,
                    id: 0,
                    tripId: 0
                  })
                ).then((res) => {
                  if (res.meta.requestStatus === "fulfilled")
                    dispatch(updatePolicyCommentText(""));
                });
              }}
            >
              <AddIcon />
            </IconButton>
          </InputAdornment>
        }
      />
    </AddCommentContainer>
  );
};

export default AddComment;
